// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"663":"72f1b069","787":"657dfff4","921":"aa6ba773"}[chunkId] + ".chunk.js";
};